export const FormatDate = (date: string | Date, dateDefault?: boolean): string => {
  if (!date) {
    return '';
  }

  let dateAux: Date = new Date(date);
  let day = dateAux.getDate() < 10 ? `0${dateAux.getDate()}` : dateAux.getDate();
  let month = dateAux.getMonth() + 1 < 10 ? `0${dateAux.getMonth() + 1}` : dateAux.getMonth() + 1;

  if (dateDefault) {
    return `${dateAux.getFullYear()}-${month}-${day}`;
  }

  return `${day}/${month}/${dateAux.getFullYear()}`;
};

export const FormatTimeZone = (date: string | Date | undefined) => {
  if (date) {
    let dateTimeZone: Date = new Date(date);
    dateTimeZone.setHours(dateTimeZone.getHours() - dateTimeZone.getTimezoneOffset() / 60);
    return dateTimeZone;
  }
  return date;
};

export const FormatDateHours = (date?: string | Date) => {
  if (!date) {
    return '';
  }

  let dateAux: Date = new Date(date);
  let hours = dateAux.getHours() < 10 ? `0${dateAux.getHours()}` : dateAux.getHours();
  let min = dateAux.getMinutes() < 10 ? `0${dateAux.getMinutes()}` : dateAux.getMinutes();
  let sec = dateAux.getSeconds() < 10 ? `0${dateAux.getSeconds()}` : dateAux.getSeconds();

  return `${FormatDate(date)} ${hours}:${min}:${sec}`;
};

export const FormatHours = (date: Date | string, hours: string) => {
  if (String(date).length < 4) {
    return date;
  }
  let dateFormat: Date = new Date(date);
  const hoursAux: String[] = hours.split(':');
  let dateAux: Date = new Date(
    dateFormat.getFullYear(),
    dateFormat.getMonth(),
    dateFormat.getDate(),
    Number(hoursAux[0]),
    Number(hoursAux[1]),
    Number(hoursAux[2])
  );
  return dateAux;
};
